export default __webpack_public_path__ + "static/media/TAROT.f6c2f2bb.png";